import * as React from 'react'

import { Button } from '../../components'
import { SpecificChartFunctionality } from '../../constants/common'
import utils from '../../utils'
import { encodeQueryString } from '../../utils/query_string'

const DRAWING_COOKIE_NAME = 'charts-draw'
export function getIsDrawingEnabled() {
  return utils.getCookie(DRAWING_COOKIE_NAME) === 'on'
}

const utmCampaign: Partial<Record<SpecificChartFunctionality, string>> = {
  [SpecificChartFunctionality.quotePage]: 'quote-draw-button',
  [SpecificChartFunctionality.futuresPage]: 'futures-interactive-chart',
  [SpecificChartFunctionality.forexPage]: 'forex-interactive-chart',
  [SpecificChartFunctionality.cryptoPage]: 'crypto-interactive-chart',
}

const testId: Partial<Record<SpecificChartFunctionality, string>> = {
  [SpecificChartFunctionality.quotePage]: 'quote-toggle-draw-btn',
  [SpecificChartFunctionality.futuresPage]: 'futures-interactive',
  [SpecificChartFunctionality.forexPage]: 'forex-interactive',
  [SpecificChartFunctionality.cryptoPage]: 'crypto-interactive',
}

export function DrawButton({
  active,
  isPremium,
  specificChartFunctionality,
}: {
  active: boolean
  isPremium: boolean
  specificChartFunctionality: SpecificChartFunctionality
}) {
  const buttonProps = React.useMemo(() => {
    if (!isPremium) {
      return {
        as: 'a',
        href: `/elite.ashx?${encodeQueryString({
          utm_source: 'finviz',
          utm_medium: 'banner',
          utm_campaign: utmCampaign[specificChartFunctionality],
        })}`,
      }
    }

    return {
      onClick: (ev: React.MouseEvent<HTMLButtonElement>) => {
        ev.preventDefault()
        const newValue = getIsDrawingEnabled() ? 'off' : 'on'

        fetch('/api/set_cookie.ashx?cookie=' + DRAWING_COOKIE_NAME + '&value=' + newValue)
          .catch(() => {})
          .then((res) => {
            if (!res?.ok) {
              // fallback to JS otherwise draw toggle won't work if API don't work
              const expires = new Date()
              expires.setMonth(expires.getMonth() + 1)
              utils.setCookie(DRAWING_COOKIE_NAME, newValue, expires)
            }

            document.location.reload()
          })
      },
    }
  }, [isPremium, specificChartFunctionality])

  return (
    <Button
      theme="chip"
      leftContent="draw"
      size="medium"
      active={active}
      data-testid={testId[specificChartFunctionality]}
      {...buttonProps}
    >
      Draw
    </Button>
  )
}
